/**
 * Runtime configuration for the admin SPA.
 *
 * API base URL resolution (priority order):
 *   1. window.__LPOS_API_BASE__  — injected via public/config.js (editable
 *      post-build without rebuilding)
 *   2. import.meta.env.VITE_API_BASE_URL — build-time
 *   3. "/api/v1" (relative) — when served from the backend itself
 */
type LposWindow = Window & { __LPOS_API_BASE__?: string };

function resolveApiBase(): string {
  const injected = (window as LposWindow).__LPOS_API_BASE__;
  if (injected && injected.trim()) return injected.replace(/\/+$/, "");
  const env = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (env && env.trim()) return env.replace(/\/+$/, "");
  return "/api/v1";
}

export const API_BASE_URL = resolveApiBase();
